module.exports = __webpack_public_path__ + "img/HACK-logo-cursor.dbd14ce1.webp";